module.exports = __webpack_public_path__ + "static/media/Signature.e54cfcfc.svg";